const url = "https://5fc1a1c9cb4d020016fe6b07.mockapi.io/api/v1/";

export const orders_url = `${url}/orders`

export const products_url = `${url}/products`

export const users_url = `${url}/users`

export const login_url=`${url}/login`;